<template>
  <div>
    <content-dashboard :hide="true">
      <v-card class="mb-10">
        <v-card-title>Filtros</v-card-title>
        <v-card-text>
          <v-form>
            <v-row>
              <v-col cols="12" md="3" sm="6">
                <v-text-field
                  outlined
                  dense
                  hide-details
                  label="Número do AIT"
                  v-model="filtro.numero_auto"
                />
              </v-col>
              <v-col cols="12" md="3" sm="6">
                <v-text-field
                  outlined
                  dense
                  hide-details
                  label="Nº Serie Aparelho"
                  v-model="filtro.numero_serie_aparelho"
                />
              </v-col>
              <v-col cols="12" md="3" sm="6">
                <v-text-field
                  outlined
                  dense
                  hide-details
                  label="Agente"
                  v-model="filtro.matricula"
                />
              </v-col>
              <v-col cols="12" md="3" sm="6">
                <v-text-field
                  outlined
                  dense
                  hide-details
                  label="Gerência"
                  v-model="filtro.gerencia"
                />
              </v-col>
              <v-col cols="12" md="3" sm="6">
                <v-text-field
                  outlined
                  dense
                  hide-details
                  label="Placa"
                  v-model="filtro.veiculo_placa"
                />
              </v-col>
              <v-col cols="12" md="3" sm="6">
                <v-text-field
                  outlined
                  dense
                  hide-details
                  label="Código Infração"
                  v-model="filtro.cod_infracao"
                  v-mask="'####-#'"
                />
              </v-col>
              <v-col cols="12" md="3" sm="6">
                <v-text-field
                  outlined
                  dense
                  hide-details
                  label="Data Inicial Infração"
                  v-model="filtro.data_inicial"
                />
              </v-col>
              <v-col cols="12" md="3" sm="6">
                <v-text-field
                  outlined
                  dense
                  hide-details
                  label="Data Final Infração"
                  v-model="filtro.data_final"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn color="primary" type="submit" @click.prevent="load(filtro)">Pesquisar</v-btn>
          <v-btn color="primary" outlined class="ml-5" @click.prevent="resetFiltro">Limpar</v-btn>
        </v-card-actions>
      </v-card>
      <v-card>
        <v-card-text>
          <v-data-table
            :loading="loading"
            :items="items"
            :headers="headers"
            hide-default-footer
            :items-per-page="15"
            :no-data-text="textTable"
          >
            <template
              v-slot:item.cod_infracao="{ item }"
            >{{item.infracao.codigo}} - {{item.infracao.digito}}</template>

            <template v-slot:item.action="{item}">
              <v-btn icon @click="showAuto(item)">
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions class="d-flex justify-center">
          <paginate :pagination="paginate" @paginate="load($event)" />
        </v-card-actions>
      </v-card>
    </content-dashboard>
    <modal-detalhes-auto :auto="auto" v-if="showModal" :show="showModal" />
  </div>
</template>
<script>
import queryString from "querystring";
import urlApi from "@/routes/urlApi";
import Paginate from "@/components/Paginate";
import { mask } from "vue-the-mask";

export default {
  name: "Index",
  directives: { mask },
  components: {
    Paginate,
    ModalDetalhesAuto: () => import("@/components/Modal/ModalDetalhesAuto.vue"),
  },
  data() {
    return {
      auto: {},
      showModal: false,
      loading: false,
      paginate: {},
      filtro: {},
      textTable: "Use o filtro para mostrar os dados",
      items: [],
      headers: [
        { text: "Número do AIT", value: "numero_auto" },
        { text: "Placa", value: "veiculo_placa" },
        { text: "Cod. Infração", value: "cod_infracao" },
        { text: "Marca", value: "veiculo_marca_modelo" },
        { text: "Agente", value: "agente.nome" },
        { text: "Data/Hora Infração", value: "data_infracao" },
        { text: "Data/Hora Lavratura", value: "data_infracao" },
        { text: "Exibir", value: "action" },
      ],
    };
  },
  methods: {
    load(filtro = null, page = 1) {
      this.loading = true;
      const filter = filtro ? `&${queryString.stringify(filtro)}` : "";
      const url = `${urlApi}/autos/talonario?page=${page}&origem=1${filter}`;
      this.$http
        .get(url)
        .then((res) => {
          this.items = res.data.data;
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
    toggleModal() {
      this.showModal = !this.showModal;
    },
    showAuto(auto) {
      const id = auto.id_auto;
      const url = `${urlApi}/autos/${id}`;
      this.$http.get(url).then((res) => {
        this.auto = { ...res.data}
        this.toggleModal()
      });
    },
    resetFiltro() {
      this.filtro = {};
      this.load();
    },
  },
};
</script>